import { selectCurrentProjectVenue } from '@/domain/project-venue/project-venue.selectors';
import { VenueDate } from '@/domain/project-venue-dates/entities/project-venue-dates.entity';
import { SnackbarGateway } from '@/domain/snackbar/gateways/snackbar.gateway';
import { createAppAsyncThunk } from '@/domain/store.thunk';
import { translate } from '@/ui/i18n';

type Result = VenueDate[];

export const getVenueDates = createAppAsyncThunk(
  'projectVenueDates/getVenueDates',
  async (
    _,
    { extra: { projectVenueDatesGateway, snackbarGateway }, getState },
  ): Promise<Result> => {
    try {
      const projectId = selectCurrentProjectVenue(getState())?.id || -1;
      const venueDates = await projectVenueDatesGateway.getAll(projectId);
      return venueDates;
    } catch (error) {
      showSnackbarError(snackbarGateway);
      throw error;
    }
  },
);

function showSnackbarError(snackbarGateway: SnackbarGateway) {
  snackbarGateway.error(translate('GetVenueDates.Message.error'));
}
